import _axios from '@/utils/request'

// 会诊类型列表
export function postClinicTypeList (params) {
    return _axios('post', `/ms-cfdu/v1/clinicManage/clinicType/page`, params)
}
// 会诊类型上下线
export function putClinicTypeState (clinicId, state) {
    return _axios('put', `/ms-cfdu/v1/clinicManage/clinicType/state/${clinicId}?state=${state}`)
}

// 院士会诊 团队成员列表
export function postClinicGroupList (params) {
    return _axios('post', `/ms-cfdu/v1/clinicManage/clinicGroup/page`, params)
}

// 院士会诊 选择团队成员列表
export function postChoseDoctorList (params) {
    return _axios('post', `/ms-cfdu/v1/clinicManage/clinicGroup/choseDoctor`, params)
}

// 团队上下线状态
export function putClinicGroupState (clinicId, state) {
    return _axios('put', `/ms-cfdu/v1/clinicManage/clinicGroup/state/${clinicId}?state=${state}`)
}

// 院士会诊 选择团队成员 -新增团队
export function postAddClinicGroup (params) {
    return _axios('post', `/ms-cfdu/v1/clinicManage/clinicGroup/add`, params)
}

// 删除团队
export function deleteClinicGroup (programId) {
    return _axios('delete', `/ms-cfdu/v1/clinicManage/clinicGroup/delete/${programId}`)
}

// 多学科会诊列表
export function postMdtClinicList (params) {
    return _axios('post', `/ms-cfdu/v1/clinicManage/mdtClinic/page`, params)
}

// 团队上下线状态
export function putMdtClinicState (mdtClinicId, state) {
    return _axios('put', `/ms-cfdu/v1/clinicManage/mdtClinic/state/${mdtClinicId}?state=${state}`)
}

// 会诊疾病
export function getSearchDisease (diseaseName) {
    return _axios('get', `/ms-dictionary/search/disease?params=${diseaseName}`)
}
// 多学科会诊删除
export function deleteMdtClinic (mdtId) {
    return _axios('delete', `/ms-cfdu/v1/clinicManage/mdtClinic/delete/${mdtId}`)
}

// 新增多学科会诊
export function postAddMdtClinic (params) {
    return _axios('post', `/ms-cfdu/v1/clinicManage/mdtClinic/add`, params)
}

// 查询团队成员信息
export function postClinicMemberList (params) {
    return _axios('post', `/ms-cfdu/v1/clinicManage/clinicMember/page`, params)
}

// 查询多学科信息
export function getMdtClinicDetail (mdtId) {
    return _axios('get', `/ms-cfdu/v1/clinicManage/mdtClinic/${mdtId}/detail`)
}

// 修改多学科信息
export function putEditMdtClinic (mdtId, params) {
    return _axios('put', `/ms-cfdu/v1/clinicManage/mdtClinic/edit/${mdtId}`, params)
}

// 团队/科室详情
export function getGroupDetail (groupId) {
    return _axios('get', `/ms-cfdu/v1/clinicManage/group/${groupId}/detail`)
}

// 编辑团队信息及成员
export function postClinicGroupUpdate (params) {
    return _axios('post', `/ms-cfdu/v1/clinicManage/clinicGroup/update`, params)
}

// 会诊类型上下移
export function putTypeChangeIndex (clinicId, operate) {
    return _axios('put', `/ms-cfdu/v1/clinicManage/clinicType/changeIndex?clinicId=${clinicId}&operate=${operate}`)
}

// 会诊类型置顶
export function putTypeChangeIndexTop (clinicId) {
    return _axios('put', `/ms-cfdu/v1/clinicManage/clinicType/top?clinicId=${clinicId}`)
}

// 单学科/院士  上下移
export function putGroupChangeIndex (groupId, operate) {
    return _axios('put', `/ms-cfdu/v1/clinicManage/clinicGroup/changeIndex?groupId=${groupId}&operate=${operate}`)
}

// 单学/院士 科置顶
export function putGroupChangeIndexTop (groupId) {
    return _axios('put', `/ms-cfdu/v1/clinicManage/clinicGroup/top?groupId=${groupId}`)
}

// 多学科上下移
export function putMdtChangeIndex (mdtClinicId, operate) {
    return _axios('put', `/ms-cfdu/v1/clinicManage/mdtClinic/changeIndex?mdtClinicId=${mdtClinicId}&operate=${operate}`)
}

// 多学科置顶
export function putMdtChangeIndexTop (mdtClinicId) {
    return _axios('put', `/ms-cfdu/v1/clinicManage/mdtClinic/top?mdtId=${mdtClinicId}`)
}
